import type { Next } from '@wix/funnel-builder-lizard'

import type { PageLogger } from '../../../../../bi/mfi'
import { onboardingAnswer } from '../../../../../bi/onboarding'
import { Save } from '../../../../../context/StorageContext/StorageContext'

type GoSkipParams = {
  pageLogger: PageLogger
  next: Next
  questionKey: string
  language: string
  save: Save
}

export const goSkip = (params: GoSkipParams) => {
  const { next, save, pageLogger, questionKey, language } = params

  void pageLogger.generalAction({ action: 'skip' })
  void onboardingAnswer({
    contentLanguage: language,
    name: '',
    navButton: 'next',
    selectedIndustryId: '',
    selectedStructureId: '',
    suggestList: 'example list',
    text: '',
  })

  save({ category: undefined })
  next({ [questionKey]: { skipped: true } })
}
